import { Record } from "./fable_modules/fable-library-js.4.17.0/Types.js";
import { record_type, bool_type } from "./fable_modules/fable-library-js.4.17.0/Reflection.js";
import { fromString } from "./fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { uncurry2 } from "./fable_modules/fable-library-js.4.17.0/Util.js";
import { Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "./fable_modules/Thoth.Json.6.0.0/Encode.fs.js";

export const disclaimerId = "disclaimer";

export class DisclaimerStorage extends Record {
    constructor(Accepted) {
        super();
        this.Accepted = Accepted;
    }
}

export function DisclaimerStorage_$reflection() {
    return record_type("LocalStorage.DisclaimerStorage", [], DisclaimerStorage, () => [["Accepted", bool_type]]);
}

export function hasAcceptedDisclaimer() {
    try {
        const x = localStorage.getItem(disclaimerId);
        const matchValue = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(DisclaimerStorage_$reflection(), undefined, undefined)), x);
        return (matchValue.tag === 1) ? false : matchValue.fields[0].Accepted;
    }
    catch (matchValue_1) {
        return false;
    }
}

export function acceptDisclaimer() {
    try {
        let x;
        const value = new DisclaimerStorage(true);
        x = toString(4, Auto_generateBoxedEncoder_437914C6(DisclaimerStorage_$reflection(), undefined, undefined, undefined)(value));
        localStorage.setItem(disclaimerId, x);
    }
    catch (matchValue) {
    }
}

